import React, { useContext, useEffect, useState } from "react"

import CommonContext from "@src/context"

import ClickableImage from "@components/clickableImage"
import Button from "@components/button"
import En from "./superSmashBros_en"
import Zh from "./superSmashBros_zh"

import bgImage from "@images/ssb-bg.jpg"
import matchImg from "@images/season3/smash-match.png"

const SuperSmashBros = () => {
  const [en, setEn] = useState(false)
  const { setBg } = useContext(CommonContext)
  useEffect(() => {
    setBg(bgImage)
  }, [])
  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <Button
          color={"blue"}
          onClick={() => {
            setEn(en => !en)
          }}
        >
          {en ? "查看中文版" : "English"}
        </Button>
      </div>
      {en ? <En /> : <Zh />}
      <div className="buttonsContainer">
        <Button large color="blue" href="http://sparkidea.mikecrm.com/ePzOL5f">
          {en ? "Register" : "报名参赛"}
        </Button>
      </div>
    </div>
  )
}

export default SuperSmashBros
